import { getToken } from '../../../auth/authenticator';
import { AuthState } from '../../../common/AuthContext.types';
import axiosClient from '../../axios-api';
import { AccountsStatement } from './AccountsStatement';
import DEVELOPMENT_FLAGS from '../../../developmentFlags';
import mockResponse from '../../../mock/accounts/statements/response.json';

export async function getAccountStatements(
  authState: AuthState,
  limit = 0,
  offset = 0,
  groupIds: ReadonlyArray<string> = [],
  institutions: ReadonlyArray<string> = [],
  productTypes: ReadonlyArray<string> = []
): Promise<AccountsStatement[] | {}> {
  if (DEVELOPMENT_FLAGS.isMock === 'true') return mockResponse;

  let finalResponse = {};

  let apiUrl = `/accounts/statements?c_id=${authState.clientId}&limit=${limit}&offset=${offset}&_t=${new Date().getTime()}`;
  groupIds.forEach((id) => {
    apiUrl += `&account_group_ids=${id}`;
  });
  institutions.forEach((institution) => {
    apiUrl += `&institutions=${encodeURIComponent(institution)}`;
  });
  productTypes.forEach((productType) => {
    apiUrl += `&product_types=${encodeURIComponent(productType)}`;
  });

  await axiosClient({
    url: apiUrl,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${await getToken()}`
    }
  })
    .then((response) => {
      finalResponse = response.data;
    })
    .catch((error) =>
      console.log('An error has occured when fetching statements - ', error?.message)
    );

  return finalResponse;
}
